__turbopack_context__.v({
  "buttonContainer": "CollectionAssortment-module-scss-module__wS4mtq__buttonContainer",
  "contentLeft": "CollectionAssortment-module-scss-module__wS4mtq__contentLeft",
  "copy": "CollectionAssortment-module-scss-module__wS4mtq__copy",
  "gridContainer": "CollectionAssortment-module-scss-module__wS4mtq__gridContainer",
  "heading": "CollectionAssortment-module-scss-module__wS4mtq__heading",
  "icon": "CollectionAssortment-module-scss-module__wS4mtq__icon",
  "iconContainer": "CollectionAssortment-module-scss-module__wS4mtq__iconContainer",
  "iconDescription": "CollectionAssortment-module-scss-module__wS4mtq__iconDescription",
  "iconsContainer": "CollectionAssortment-module-scss-module__wS4mtq__iconsContainer",
  "imageContainer": "CollectionAssortment-module-scss-module__wS4mtq__imageContainer",
  "leftColumn": "CollectionAssortment-module-scss-module__wS4mtq__leftColumn",
  "logoContainer": "CollectionAssortment-module-scss-module__wS4mtq__logoContainer",
  "recommendationsContainer": "CollectionAssortment-module-scss-module__wS4mtq__recommendationsContainer",
});
